import { v4 as uuid } from "uuid";
import type { ManagedQrCode } from "./types";

const QR_PREFIX = "qr";

export function parseBatchSize(value: string): number | null {
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed < 1 || parsed > 200) {
    return null;
  }
  return parsed;
}

export function canGenerateBatch(
  batchSizeInput: string,
  isBusy: boolean,
): boolean {
  if (isBusy) {
    return false;
  }

  return parseBatchSize(batchSizeInput) !== null;
}

export function generateQrCodesBatch(batchSize: number): ManagedQrCode[] {
  const now = new Date().toISOString();
  const generated: ManagedQrCode[] = [];

  for (let index = 0; index < batchSize; index += 1) {
    generated.push({
      id: uuid(),
      payload: `${QR_PREFIX}_${uuid()}`,
      state: "unused",
      assignedEntityId: null,
      assignedAt: null,
      createdAt: now,
      replacedById: null,
    });
  }

  return generated;
}
